<template>
  <b-modal v-model="visible" :title="question" centered size="md" :hide-footer="true" @hidden="answer(false)">
    <div class="float-right">
      <button type="button" class="btn btn-secondary-outline" @click="answer(false)">Loobu</button>
      <button type="button" class="btn btn-primary" @click="answer(true)">Kinnita</button>
    </div>
  </b-modal>
</template>

<script>
  import Vue from 'vue'

  let eventBus = new Vue()

  export default {
    install(Vue, options) {
      Vue.prototype.$confirm = function(question, action) {
        eventBus.$once('answer', response => {
          if (response) action()
        })
        eventBus.$emit('ask', question)
      }
    },
    data() {
      return {
        question: '',
        visible: false
      }
    },
    methods: {
      answer(result) {
        this.visible = false
        eventBus.$emit('answer', result)
      }
    },
    created() {
      eventBus.$on('ask', question => {
        this.question = question
        this.visible = true
      })
    }
  }
</script>